<template>
  <div>
    <span class="summarize-news-btn mr-1" @click="routeToSummarizeNewsModal">
        View news summary
    </span>
  </div>
</template>

<script>
import SummarizeNewsModal from "../modals/SummarizeNewsModal";
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";
import { mapGetters } from "vuex";
import * as CONSTANTS from "@/store/constants";
import { createStandardModal } from "@/utils/modalHelper";

export default {
  name: "summarize-news-button",
  mixins: [HomebaseMixpanelMixin],
  components: {
    SummarizeNewsModal
  },
  data() {
    return {
      modalInstance: null
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },

  created() {
    // Launch modal if directly navigating to /news-summary
    console.log('[SummarizeNewsButton] created(), route:', this.$route.path, 'NEWS_SUMMARY_PATH:', CONSTANTS.NEWS_SUMMARY_PATH);
    if (this.$route.path === CONSTANTS.NEWS_SUMMARY_PATH) {
      console.log('[SummarizeNewsButton] Route matches, launching modal');
      // Use nextTick to ensure DOM and route are fully ready
      this.$nextTick(() => {
        this.launchSummarizeNewsModal();
      });
    }
  },

  methods: {

    routeToSummarizeNewsModal() {
        this.trackGenerateViewNewsSummaryClicked();
        this.$router.push(CONSTANTS.NEWS_SUMMARY_PATH);
        // Don't call modal here - the created() hook will handle it
        // when component is recreated with new route key
    },

    launchSummarizeNewsModal() {
      console.log('[SummarizeNewsButton] launchSummarizeNewsModal called');
      // Create modal instance using vue-final-modal v4 API
      this.modalInstance = createStandardModal(SummarizeNewsModal, {
        props: {},
        callbacks: {
          onClosed: () => {
            console.log('[SummarizeNewsButton] Modal closed, navigating to /');
            this.$router.push("/");
          }
        }
      });

      console.log('[SummarizeNewsButton] Modal instance created, calling open()');
      // Open the modal
      this.modalInstance.open();
    },
  },

  beforeUnmount() {
    // Cleanup modal instance when component is destroyed
    if (this.modalInstance) {
      this.modalInstance.destroy();
    }
  }
};
</script>

<style scoped>
.summarize-news-btn {
  font-family: artifaktElementBold;
  font-size: 16px;
  color: var(--secondary-color);
  text-decoration: underline;
}
.summarize-news-btn:hover {
  cursor: pointer;
  color: var(--secondary-color);
}
</style>